<template>
    <div class="">

        <EngringsLandingEngagmentLandingIndia v-if="$country.is_india"/>
        <EngringsLandingEngagementLandingUs  v-else/>
  
    </div>
</template>

<script setup>
    const { $country } = useNuxtApp()

</script>

<style scoped>

</style>
